module.exports = __webpack_public_path__ + "static/media/oret-studio-1.2683472b.jpg";